var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomerType = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.875,
    cy: 9.5,
    r: 7.917,
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 1.583
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 1.583,
    d: "M6.613 12.473c.39.338.904.582 1.458.742.56.162 1.18.243 1.803.243.622 0 1.242-.081 1.803-.243.553-.16 1.067-.404 1.457-.742"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.499,
    cy: 7.917,
    r: 0.99,
    fill: "#7E869E",
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 0.396
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.249,
    cy: 7.917,
    r: 0.99,
    fill: "#7E869E",
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 0.396
  })));
};
export default SvgCustomerType;